<script lang="ts">
    import Icon from "../../widgets/Icon.svelte"
    import { mdiPlusCircleOutline, mdiCloseCircleOutline, mdiCalendar } from "@mdi/js"
    import { _ } from "svelte-i18n"

    import Rule from "./Rule.svelte"
    import ExceptionRule from "./ExceptionRule.svelte"
    import Calendar from "../../widgets/calendars/Calendar.svelte"

    export let priceCalculation: PriceCalculation
    $: if (!priceCalculation) {
        priceCalculation = {
            id: null,
            daysValid: null,
            dealerNumber: null,
            groupName: "",
            calculation: {
                discountPercent: null,
                surchargePercent: null,
                type: "surcharge",
            },
            vat: null,
            globalCalculation: null,
            exception: { rules: [] },
            // deprecated, aber im Typ Pflicht
            ruleBasedCalculation: [],
            expiryDates: [],
        }
    }

    const removeExpiryDate = (index: number) => {
        priceCalculation.expiryDates.splice(index, 1)
        priceCalculation.expiryDates = priceCalculation.expiryDates
    }

    const addExpiryDate = () => {
        let date = new Date()
        let cDate =
            date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2)
        priceCalculation.expiryDates.push({
            date: cDate,
            comment: "",
        })
        priceCalculation.expiryDates = priceCalculation.expiryDates
    }

    // @ts-ignore
    $: if (!priceCalculation.calculation) priceCalculation.calculation = priceCalculation.globalCalculation

    const i18n = {
        datePlaceholder: $_("components.pcalc.datePlaceholder"),
        commentPlaceholder: $_("components.pcalc.commentPlaceholder"),
        daysValidPlaceholder: $_("components.pcalc.daysValidPlaceholder"),
        internalComment: $_("components.pcalc.internalComment"),
        commentNote: $_("components.pcalc.commentNote"),
        addFixedDate: $_("components.pcalc.addFixedDate"),
    }
</script>

<section data-cy="standard-calculation">
    <Rule bind:rule="{priceCalculation.calculation}" index="{-1}" />
</section>

<ExceptionRule bind:exception="{priceCalculation.exception}" {priceCalculation} />
<section>
    <div class="section-title">{$_("components.pcalc.validity")}</div>
    <div class="row">
        <div class="col-sm-3 no-padding">
            <div class="layout layout-wrap layout-gap-md">
                <div class="inputholder has-append no-input-margin">
                    <input
                        type="number"
                        data-cy="daysValid"
                        step="1"
                        min="1"
                        placeholder="{$_('components.pcalc.daysValidPlaceholder')}"
                        bind:value="{priceCalculation.daysValid}"
                        required
                    />
                    <div class="input-append">{$_("components.pcalc.days")}</div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="mt-md">
    <div class="section-title">{$_("components.pcalc.fixedDates")}</div>
    {#each priceCalculation.expiryDates as _, index}
        <div class="row">
            <div class="col-sm-3 mt-xs no-padding-left">
                <div class="inputholder has-append no-input-margin">
                    <Calendar
                        placeholder="{i18n.datePlaceholder}"
                        className="with-label-size"
                        dataCy="expiryDate"
                        bind:dateValueString="{priceCalculation.expiryDates[index].date}"
                        buttonInputAppend="{true}"
                    />
                </div>
            </div>
            <div class="col-sm-9 mt-xs no-padding-right">
                <div class="inputholder haslabel has-append no-input-margin">
                    <label for="expiryDates{index}"
                        >{i18n.internalComment}
                        <small>{i18n.commentNote}</small></label
                    >
                    <input
                        id="expiryDates{index}"
                        type="text"
                        data-cy="expiryDateComment"
                        placeholder="{i18n.commentPlaceholder}"
                        bind:value="{priceCalculation.expiryDates[index].comment}"
                    />
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <div
                        class="removeExpiryDate"
                        data-cy="removeExpiryDate"
                        role="button"
                        tabindex="0"
                        on:click="{() => {
                            removeExpiryDate(index)
                        }}"
                    >
                        <Icon path="{mdiCloseCircleOutline}" width="24" height="24" viewBox="0 0 24 24" />
                    </div>
                </div>
            </div>
        </div>
        {#if priceCalculation.expiryDates[index + 1]}
            <div class="seperator mt-sm mb-xs"></div>
        {/if}
    {/each}

    <div class="layout justify-content-center mt-md">
        <button type="button" class="btn btn-secondary btn-outline" data-cy="addExpiryDate" on:click="{addExpiryDate}">
            <Icon path="{mdiPlusCircleOutline}" />
            <span>{$_("components.pcalc.addFixedDate")}</span>
        </button>
    </div>
</section>
